import util from './util'

let Link = Vue.component('colored-link', {
	props: ['type'],
	data() {
		return {
			accentColor: '#000',
			currentColor: '#000',
			inactiveColor: '#000'
		}
	},
	mounted() {
		this.accentColor = util.getRandomColor()
	},
	methods: {
		onMouseOver() {
			this.currentColor = this.accentColor
		},
		onMouseLeave() {
			this.currentColor = this.inactiveColor
		},
		onClick(e) {
			this.inactiveColor = this.accentColor
			util.onClickDefaultLink(e)
		}
	},
	template: `
	<a @click="onClick" @mouseover="onMouseOver" @mouseleave="onMouseLeave" :data-type="type" data-cursor="internal" :data-color="this.accentColor" :style="{ color: this.currentColor }">
		<slot></slot>
	</a>`
})

export default Link
